
import { timer as observableTimer,  Observable } from 'rxjs';
import { faSpinner, IconDefinition } from "@fortawesome/free-solid-svg-icons";

/**
 * Message component
 * @Input() label: any;
 * @Input() value: any;
 * @Input() spinner: boolean = false;
 * @Input() type: string = "info"; //success, info, warning
 * @Input() autoclose: boolean= false;
 * @Input() fullwidth: boolean= false; width 80%
 */
import { Component, Input } from '@angular/core';

@Component({
    selector: 'message',
    template: `
        <div
          class="message-body {{type}} {{width}}"
          *ngIf="visible">
            <fa-icon *ngIf="spinner" [icon]="iconSpinner" size="1x" [pulse]="true" [fixedWidth]="true"></fa-icon>
            <span *ngIf="label">
                <span [innerHTML]="label"></span> :
            </span>
            <span>
                <span [innerHTML]="value"></span>
            </span>
        </div>
    `
})
export class MessageComponent {
    @Input()
    public label: any;
    @Input()
    public value: any;
    @Input()
    public spinner: boolean = false;
    @Input()
    public type?: string; //success, info, warning
    @Input()
    public autoclose: boolean= false;
    @Input()
    public fullwidth: boolean= false;

    public iconSpinner: IconDefinition = faSpinner;

    public visible=true;
    public width="";
    public ticks = 0;
    public func(t: any) {
        this.visible=false;
    }


    public ngOnInit(): void {

        if(this.autoclose){
            this.launchClose();
        }

        if(this.fullwidth){
          this.width = "fullwidth";
        }

    }

    public launchClose(): void{
      this.visible=true;
      const timer = observableTimer(3000);
      timer.subscribe((t) => {
        this.func(t);
      });
    }
}
